// @flow

import { BaseService } from "./base-service";
import { FetchApi } from "../model/fetch";

export class ResetPasswordService extends BaseService {
    constructor(
        fetchApi: FetchApi,
        options: {
            basepath: string
        }
    ) {
        super(fetchApi, options);
    }
    resetPassword = async (password: string, token: string): Promise<void> => {
        return await this.post(`/api/resetpassword`, null, {
            token,
            password
        });
    };
}
